import '@/assets/css/payment-function.scss';
import baseComponent from '@/scripts/baseComponent';
import paymentApi from '@/api/payment';
import { mapState } from "vuex";
import commonActionHandle from "@/commonActionHandle";

export default {

    extends: baseComponent,

    data() {
        return {
            isLoadingCoupon: false,
            giftCardCode: '',
        }
    },
    computed: {
        ...mapState({
            userInfo: state => state.auth.user,
        }),
    },

    created() {

    },

    mounted() {

    },

    methods: {

        // Submit gift card
        submitGifCard() {
            this.isLoadingCoupon = true;
            let request = {
                couponCode: this.giftCardCode,
                appCode: 'gpuhub'
            }
            paymentApi.applyCoupon(request)
                .then((res) => {
                    try {
                        switch (res.errorCode) {
                            default:
                                commonActionHandle.showCustomSuccess(
                                    "Success !",
                                    res.message,
                                );
                                break;
                        }
                    } catch (error) {
                        console.error(error);
                    }
                    this.isLoadingCoupon = false;
                })
                .catch(error => {
                    try {
                        if (error.name === 'Error') {
                            this.$store.dispatch("common/showCommonError", error);
                        } else {
                            switch (error.errorCode) {
                                default:
                                    commonActionHandle.showCustomError(
                                        "Received gift card failed...",
                                        error.message,
                                        () => { },
                                        () => { },
                                        '',
                                        '',
                                        false,
                                    );
                                    break;
                            }
                        }
                    } catch (error) {
                        console.error(error);
                    }
                    this.isLoadingCoupon = false;
                });
        },
    }
}